import React, { useEffect, useState } from "react";
import "./app.css";
import CheckIcon from "@mui/icons-material/Check";
import { getLang } from "../lang/getlang";
const OnboardPreview = ({ cardData, activetab }) => {
  const [active, setActive] = useState("genting_dream");
  const [notes, setNotes] = useState("");
  useEffect(() => {
    let item = cardData?.dataArray.filter((item) => item?.ship === active)[0];
    setNotes(
      activetab === "english"
        ? item?.note
        : activetab === "simplified_chinese"
        ? item?.simplified_chinese_note
        : activetab === "arabic"
        ? item?.arabic_note
        : activetab === "bahasa"
        ? item?.bahasa_note
        : item?.traditional_chinese_note
    );
  }, [active, activetab, cardData]);
  useEffect(()=>{
    console.log(cardData?.dataArray
              .filter((item) => item?.ship === active)?.[0])
  },[active, activetab, cardData])
  return (
    <div style={{ marginLeft: "10px" }}>
      <h1 className="title-color mb-4"> </h1>
      <div
        className="col-12 text-center mb-5"
        style={{ display: "flex", alignItems: "center", width: "100%" }}
      >
        <ul
          className="page-tab scroll-tab"
          style={{
            display: "flex",
            gap: "10px",

            listStyleType: "none",
            padding: 0,
            alignItems: "center",
            justifyContent: "center",
            margin: 0,
            width: "100%",
          }}
        >
          <li
            onClick={() => setActive("genting_dream")}
            data-scroll-tab-seq={1}
            className=""
          >
            {getLang("genting_dream", activetab)}
          </li>
          <li
            onClick={() => setActive("star_navigator")}
            data-scroll-tab-seq={2}
            className=""
          >
            {getLang("resorts_world_one", activetab)}
          </li>
           <li
            onClick={() => setActive("star_voyager")}
            data-scroll-tab-seq={2}
            className=""
          >
            {getLang("star_voyager", activetab)}
          </li>
        </ul>
      </div>
      <div
        style={{
          display: "flex",
          // alignItems: "center",
          flexWrap: "wrap",
          flexDirection: "row",
          gap: "10px",
        }}
      >
        <div className="row" style={{ width: "100%", padding: "10px" }}>
          <div style={{ width: "100%" }}>
            <div className="col-12 text-center scroll-content-1">
              {" "}
              <h2
                className="mb-5 title-grey"
                style={{ direction: activetab === "arabic" && "rtl" }}
              >
                {activetab === "english"
                  ? cardData?.title
                  : activetab === "simplified_chinese"
                  ? cardData?.simplified_chinese_title
                  : activetab === "bahasa"
                  ? cardData?.bahasa_title
                  : cardData?.traditional_chinese_title}
              </h2>
            </div>
          </div>
          <table style={{ width: "100%" }} className="beverage-package1">
            <thead>
              <tr>
                <th scope="col">&nbsp;</th>
                <th scope="col">{getLang("treat_package", activetab)}
                  <br/>{cardData?.dataArray
              .filter((item) => item?.ship === active)?.[0]?.treat_package_price}</th>
                <th scope="col">{getLang("deluxe_package", activetab)}  <br/>{cardData?.dataArray
              .filter((item) => item?.ship === active)?.[0]?.deluxe_package_price}</th>
                <th scope="col">{getLang("elite_package", activetab)}  <br/>{cardData?.dataArray
              .filter((item) => item?.ship === active)?.[0]?.elite_package_price}</th>
              </tr>
            </thead>
            {cardData?.dataArray
              .filter((item) => item?.ship === active)
              ?.map((item) => (
                <tbody>
                  {item?.dataArray?.map((item) => (
                    <tr>
                      <td>
                        <span className="title1">
                          {" "}
                          <div
                            dangerouslySetInnerHTML={{
                              __html:
                                activetab === "english"
                                  ? item?.title
                                  : activetab === "simplified_chinese"
                                  ? item?.simplified_chinese_title
                                  : activetab === "arabic"
                                  ? item?.arabic_title
                                  : activetab === "bahasa"
                                  ? item?.bahasa_title
                                  : item?.traditional_chinese_title,
                            }}
                          />
                        </span>
                        <br />
                      </td>

                      <td className="center">
                        <span style={{ color: "red" }}>
                          {item?.treat_package == "yes" && <CheckIcon />}
                        </span>
                      </td>

                      <td className="center">
                        <span style={{ color: "red" }}>
                          {item?.deluxe_package == "yes" && <CheckIcon />}
                        </span>
                      </td>
                      <td className="center">
                        <span style={{ color: "red" }}>
                          {item?.elite_package == "yes" && <CheckIcon />}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              ))}
          </table>
        </div>
      </div>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div style={{ marginTop: "30px", fontWeight: "bold" }}>
          {" "}
          {getLang("note", activetab)}
        </div>
        <div
          style={{ marginLeft: "20px" }}
          dangerouslySetInnerHTML={{
            __html: notes,
          }}
        />
      </div>
    </div>
  );
};

export default OnboardPreview;
